import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'kanban';

const kanbanService = {
  getItemsByType: (type, data, allColumns) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(allColumns)}`,
      data,
    });
  },

  getStatusByType: (type) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/statusForType/${encodeURIComponent(type)}`,
    });
  },

  updateItemsByType: (type, id, statusId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(statusId)}`,
      data,
    });
  },

  updatePriorityByType: (type, id, priorityId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/priority/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(priorityId)}`,
    });
  },

  updateTagByType: (type, id, tagId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tag/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(tagId)}`,
    });
  },

  getItemById: (type, id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
    });
  },

  createMessage: (data, type) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}`,
      data,
    });
  },

  updateMessage: (data, type, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteItemByType: (type, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteItem/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
    });
  },

  addOrRemoveRespPersonByType: (type, id, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/addOrRemoveRespPerson/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(userId)}`,
    });
  },

  updateRespPersonByType: (type, id, userId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/updateRespPerson/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(userId)}`,
    });
  },
};
export default kanbanService;
